<template>
    <project-step-container
            prev-to="js_rapid_experiments_with_customers_18"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject">
        <b-row class="first-form">
            <b-col cols="12" class=" simple-text" tabindex="0">
                {{getMessage(19, 'rapidexperiment-sub')}}
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col cols="12">
                <LinkStyleGuide :url="getMessage(19, isJACareerEntrepreApp ? 'rapidexperiment-link-new' : 'rapidexperiment-link')"
                                target="_blank"
                                icon-name="icon-link"
                                :text="getMessage(19, 'rapidexperiment-link-text')"></LinkStyleGuide>
            </b-col>
        </b-row>
    </project-step-container>
</template>

<script>
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import LinkStyleGuide from "../../../core/Components/LinkStyleGuide"
    import {Steps} from "@/modules/JobShadow/Utils";
    import {ConflictSyn, Project} from "@/core/Utils";

    export default {
        name: "RapidExperimentsWithCustomers19",
        components: {ProjectStepContainer, LinkStyleGuide},
        data(){
            return{
                step:Steps.FORM_JS_RAPID_JOB_SHADOW,
            }
        },
        methods: {
            openVideo() {
                this.$refs.video.playVideo()
            },
            updateProject() {
                const index = this.$route.params.index
                const stepNumber = Steps.getStepFromForm(this.step)

                Project.saveProjectStep(index, this.step, stepNumber, {}, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: 'js_rapid_experiments_with_customers_20', params: {index}})
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"

    .simple-text-second
        font font-sourcesans-bold
        font-size 14px
        color color-4
</style>

